export default "__VITE_ASSET__CmkmPYao__"